export default __webpack_public_path__ + "static/media/B42.41695354.png";